import React, { Fragment, PureComponent } from 'react';
import { Column, Row } from '../../../components/Grid';
import { ContentHeader } from '../../../components/layout/ContentHeader';
import { TextLink } from '../../../components/Link';
import { ListItem } from '../../../components/List';
import { Section } from '../../../components/Section';
import {
  Sitemap,
  SitemapList,
  SitemapTitle
} from '../../../components/Sitemap';
import { selectMenu } from '../../../provider/Typo3Provider/selectors';
import { CType } from '../../../provider/Typo3Provider/types';
import {
  withTypo3,
  WithTypo3Props
} from '../../../provider/Typo3Provider/withTypo3';

type SitemapContainerProps = CType & {};

class SitemapContainer extends PureComponent<
  SitemapContainerProps & WithTypo3Props
> {
  public render() {
    const { header, subheader, typo3 } = this.props;
    const locations = selectMenu(typo3, 'locations');
    const main = selectMenu(typo3, 'main');
    const footer = selectMenu(typo3, 'footer');
    const meta = selectMenu(typo3, 'meta');
    const [contactPageEntry = null] = selectMenu(typo3, 'contactpage');

    const mainList = [...main, ...locations];

    return (
      <Section>
        <ContentHeader header={header} subheader={subheader} />
        <Sitemap>
          <Row>
            <Column small={12} medium={6}>
              <SitemapList>
                {mainList.map(item => (
                  <ListItem key={item.uid}>
                    <TextLink to={item.link}>{item.title}</TextLink>
                    {!!item.children && (
                      <SitemapList>
                        {item.children.map(child => (
                          <ListItem key={child.uid}>
                            <TextLink
                              to={child.link}
                              style={{ fontWeight: 'normal' }}
                            >
                              {child.title}
                            </TextLink>
                          </ListItem>
                        ))}
                      </SitemapList>
                    )}
                  </ListItem>
                ))}
              </SitemapList>
              <SitemapList>
                {meta.map((item, key) => (
                  <Fragment key={item.uid}>
                    {key < meta.length - 1 && (
                      <ListItem>
                        <TextLink to={item.link}>{item.title}</TextLink>
                      </ListItem>
                    )}
                  </Fragment>
                ))}
                {contactPageEntry && (
                  <ListItem>
                    <TextLink to={contactPageEntry.link}>
                      {contactPageEntry.title}
                    </TextLink>
                  </ListItem>
                )}
              </SitemapList>
            </Column>
            <Column small={12} medium={6}>
              {footer.map((item, key) => (
                <Fragment key={item.uid}>
                  <SitemapTitle>{item.title}</SitemapTitle>
                  {!!item.children && (
                    <SitemapList>
                      {item.children.map(child => (
                        <ListItem key={child.uid}>
                          <TextLink
                            to={child.link}
                            style={{ fontWeight: 'normal' }}
                          >
                            {child.title}
                          </TextLink>
                        </ListItem>
                      ))}
                    </SitemapList>
                  )}
                </Fragment>
              ))}
            </Column>
          </Row>
        </Sitemap>
      </Section>
    );
  }
}

export default withTypo3(SitemapContainer);
